import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getSuperSpeedFromLS } from 'swag-client-common/utils/super-speed-local-storage.utils';
import { embellishmentMethodMouseOnSelector, isLimitedEditionSelector, shouldDisplayEmbellishmentErrorTooltipSelector } from '../../../../../../../redux/product/product.selectors';
import { EmbellishmentMethodTooltipComponent } from './embellishment-method-tooltip';
const mapStateToProps = createStructuredSelector({
  embellishmentMethodMouseOn: embellishmentMethodMouseOnSelector,
  isLimitedEdition: isLimitedEditionSelector,
  isSuperSpeedActive: getSuperSpeedFromLS,
  shouldDisplayEmbellishmentErrorTooltip: shouldDisplayEmbellishmentErrorTooltipSelector
});
export const EmbellishmentMethodTooltip = connect(mapStateToProps)(EmbellishmentMethodTooltipComponent);